import PrintHeadingOfLogo from 'src/content/modules/Members/MemberAccount/Expense/components/PrintHeadingOfLogo';
import PrintReceivePaymentCommonCom from './PrintReceivePaymentCommonCom';
import { IReceiveReportType } from '../types/receiveReportTypes';
import dayjs, { Dayjs } from 'dayjs';
import { Box } from '@mui/system';

const PrintReceivePaymentReport = ({
  response,
  date,
}: {
  response: IReceiveReportType;
  date: {
    startDate: Dayjs;
    endDate: Dayjs;
  };
}) => {
  return (
    <div style={{ padding: '3px' }}>
      <PrintHeadingOfLogo />
      <Box sx={{ display: 'flex', justifyContent: 'center', my: 1 }}>
        Receive-Payment
      </Box>

      <PrintReceivePaymentCommonCom
        data={response?.collection}
        crOrDr='Cr'
        fromDateTodate={`${dayjs(date.startDate).format('DD-MM-YYYY')} to ${dayjs(date.endDate).format('DD-MM-YYYY')}`}
        onaceTimeShowOpeningBalnce
        totalReceivePaymentTitle='Total Receive'
        openingBalanceBankAmount={response?.opening_balance?.bank}
        openingBalanceCashAmount={response?.opening_balance?.cash}
        openingBalanceDate={dayjs(response?.opening_balance?.date)?.format(
          'DD-MM-YYYY'
        )}
      />
      <Box sx={{ marginTop: '15px' }}>
        <PrintReceivePaymentCommonCom
          data={response?.expense}
          crOrDr='Dr'
          fromDateTodate={`${dayjs(date.startDate).format('DD-MM-YYYY')} to ${dayjs(date.endDate).format('DD-MM-YYYY')}`}
          totalReceivePaymentTitle='Total Payment'
        />
      </Box>
    </div>
  );
};

export default PrintReceivePaymentReport;
